<template lang="html">
  <div id="cookie-notice" role="banner" class="cn-bottom" style="color: rgb(255, 255, 255); background-color: rgb(0, 0, 0); visibility: visible;">
    <div class="cookie-notice-container">
      <span v-if="language =='en'" id="cn-notice-text">
        We use cookies (our own and those of third parties) to make our websites easier for you to use and to display advertisements in accordance with your browser settings. By continuing to use our websites, you consent to the use of cookies. Please see our Cookie Policy for more information on cookies and information on how you can change your browser's cookie settings:
        <a href="/cookie-policy">Cookie Policy</a>
      </span>
      <span v-if="language =='de'" id="cn-notice-text">
        Wir setzen Cookies (eigene und von Drittanbietern) ein, um Ihnen die Nutzung unserer Webseiten zu erleichtern und Ihnen Werbemitteilungen im Einklang mit Ihren Browser-Einstellungen anzuzeigen. Mit der weiteren Nutzung unserer Webseiten sind Sie mit dem Einsatz der Cookies einverstanden. Weitere Informationen zu Cookies und Hinweise, wie Sie die Cookie-Einstellungen Ihres Browsers ändern können, entnehmen Sie bitte unserer
        <a href="/cookie-policy">Cookie-Richtlinie</a>
      </span>
      <a id="cn-accept-cookie" @click="acceptCookies" data-cookie-set="accept" class="cn-set-cookie cn-button button">
        <span v-if="language =='en'">Accept</span>
        <span v-if="language =='de'">Akzeptieren</span>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data(){
    return {
      gaProperty : "UA-137260575-1"
    }
  },
  computed: {
    ...mapGetters(['currentScenario','language','podSize','infoOpened'])
  },
  mounted(){
    this.initCookies();
  },
  methods:{
    initCookies(){
      // Disable tracking if the opt-out cookie exists.
      var enableStr = 'ga-enable-' + this.gaProperty;
      if (document.cookie.indexOf(enableStr + '=true') > -1) {
        window[enableStr] = true;
        this.sendCookies();
      }
      else{
        setTimeout(function(){
          $("#cookie-notice").addClass("visible");
        },500);
      }
    },
    acceptCookies(){
      this.gaEnable();
      this.sendCookies();
      $("#cookie-notice").removeClass("visible");
    },
    sendCookies(){
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', this.gaProperty,{ 'anonymize_ip': true });
      gtag('create', this.gaProperty, { 'anonymize_ip': true });
      ga('set', 'anonymizeIp', true);
      gtag('send', 'pageview', {
        'anonymizeIp': true
      });
    },
    gaEnable() {
      var enableStr = 'ga-enable-' + this.gaProperty;
      document.cookie = enableStr + '=true; expires=Tue, 31 Dec 2019 23:59:59 UTC; path=/';
      window[enableStr] = true;
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin cubic-transition($duration) {
  -webkit-transition: all $duration cubic-bezier(0, 0, 0.2, 1);
  -moz-transition: all $duration cubic-bezier(0, 0, 0.2, 1);
  -ms-transition: all $duration cubic-bezier(0, 0, 0.2, 1);
  -o-transition:all $duration cubic-bezier(0, 0, 0.2, 1);
  transition: all $duration cubic-bezier(0, 0, 0.2, 1);
}
#cookie-notice.cn-bottom {
  display: block;
  visibility: hidden;
  position: fixed;
  z-index: 1000020;
  font-size: 13px;
  line-height: 20px;
  left: 0;
  right: 0;
  bottom: -192px;
  text-align: center;
  background: none;
  min-width: 0;
  width: auto;
  z-index: 9999999;
  @include cubic-transition(.4s);
  opacity: 0;
  &.visible{
    bottom:0;
    opacity: 1;
  }

  .cookie-notice-container {
    padding: 16px 1%;
    text-align: right;
    width: 90%;
    background: #0a0a0a;
    min-height: 42px;
    span{
      color: white !important;
      a{
        color: white !important;
        text-decoration: underline;
      }
    }
  }

  #cn-notice-text {
    display: inline-block;
    padding: 1em 2em 1em 0;
    line-height: 1.4em;
    font-size: 12px;
    max-width: 75%;
    vertical-align: middle;
  }

  .cn-button {
    margin-left: 0;
    border: 0;
    padding: 1em 2em;
    line-height: 1.4em;
    font-size: 12px;
    box-sizing: border-box;
    height: auto;
    font-weight: 400;
    -webkit-box-shadow: none;
    box-shadow: none;
    color: #333;
    text-align: center;
    font-family: 1rem;
    background: #fff;
    border-radius: 2px;
    border: 1px solid #c8c8c8;
    padding: 10px 1em;
    height: 47px;
    line-height: 1.4em;
    font-size: .75rem;
    text-transform: uppercase;
    position: relative;
    box-shadow: none;
    border-radius: 2px;
    -webkit-transition: all 200ms ease-out;
    transition: all 200ms ease-out;
    span{
      color: #333 !important;
    }
  }
}

</style>
